<template>
  <v-app>
    <headbar />
    <v-main>
      <page />
    </v-main>
    <myfooter />
  </v-app>
</template>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC&display=swap");
*{
  font-family: 'Noto Sans TC', sans-serif; 
}

</style>

<script>

import page from './page.vue';
import headbar from '../../components/headbar'
import myfooter from '../../components/footer.vue'

export default {
  name: 'App',
  components: {
    headbar,
    page,
    myfooter,
  },

};
</script>
